// ServiceSection.jsx
import React, { useState, useEffect } from 'react';
import superior from '../assets/images/superior.png';
import fastDelivery from '../assets/images/fast-delivery.png';
import reliability from '../assets/images/reliability.png';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const ServiceSection = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 600);
        return () => clearTimeout(timer);
    }, []);

    const features = [
        {
            icon: superior,
            alt: 'routing',
            title: 'Become a Rotiey Maker',
            description: 'Join as a Rotiey Maker – earn from home by making fresh rotis and become self-reliant!',
            link: '/partner',
            linkText: 'Start Earning',
        },
        {
            icon: fastDelivery,
            alt: '3d-rotate',
            title: 'Become a Delivery Partner',
            description: 'Join as a Delivery Partner – deliver happiness, earn on your schedule, and grow with us!',
            link: '/earning',
            linkText: 'Join Us Now',
        },
        {
            icon: reliability,
            alt: 'truck',
            title: 'Get the Homemade Experience',
            description: 'Get the Homemade Experience – enjoy fresh, healthy, and lovingly cooked meals just like home!',
            link: '#app',
            linkText: 'Get the App',
        },
    ];

    if (loading) {
        return (
            <section className="py-12">
                {/* Desktop Placeholder */}
                <div className="container mx-auto px-4 hidden md:block">
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="flex animate-pulse justify-center">
                                <div className="flex flex-col items-center text-center p-6">
                                    <div className="border border-gray-300 rounded-lg flex items-center justify-center mb-3 p-2">
                                        <div className="w-12 h-12 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded"></div>
                                    </div>
                                    <div className="space-y-2">
                                        <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-48 mx-auto"></div>
                                        <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-80 mx-auto"></div>
                                        <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-60 mx-auto"></div>
                                        <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-32 mx-auto mt-4"></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mobile Placeholder */}
                <div className="container mx-auto px-4 block md:hidden">
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="flex border-b pb-3 animate-pulse">
                                <div className="flex items-center w-full">
                                    {/* Icon Placeholder */}
                                    <div className="border border-gray-300 rounded-lg flex items-center justify-center mr-4 p-2">
                                        <div className="w-16 h-16 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded"></div>
                                    </div>
                                    
                                    {/* Text Placeholder */}
                                    <div className="space-y-2">
                                        <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-40"></div>
                                        <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-48"></div>
                                        <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-44"></div>
                                        <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-20 mt-2"></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="py-12">
            <div className="container mx-auto px-4 hidden md:block">
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <div key={index} className="flex">
                            <div
                                className={`flex flex-col items-center text-center p-6 
                                    }`}
                            >
                                <div className="border border-gray-300 rounded-lg flex items-center justify-center mb-3 p-2">
                                    <img
                                        className="w-12 object-contain"
                                        src={feature.icon}
                                        alt={feature.alt}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <h5 className="text-lg font-semibold text-gray-900">{feature.title}</h5>
                                    <h6 className="text-sm text-gray-600">{feature.description}</h6>
                                    <a
                                        href={feature.link}
                                        className="inline-flex items-center text-theme2 hover:text-black font-semibold mt-4"
                                    >
                                        {feature.linkText}
                                        <FaArrowRight className='ml-2' />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container mx-auto px-4 block md:hidden">
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <div key={index} className="flex border-b pb-3">
                            <div className="flex items-center w-full">
                                {/* Icon Section */}
                                <div className="border border-gray-300 rounded-lg flex items-center justify-center mr-4 p-2">
                                    <img
                                        className="w-16 object-contain"
                                        src={feature.icon}
                                        alt={feature.alt}
                                    />
                                </div>

                                {/* Text Section */}
                                <div className="space-y-2">
                                    <h5 className="font-semibold text-gray-900">{feature.title}</h5>
                                    <h6 className="text-sm text-contentcolor">{feature.description}</h6>
                                    <a
                                        href={feature.link}
                                        className="inline-flex items-center text-theme2 hover:text-black text-sm font-semibold mt-2"
                                    >
                                        {feature.linkText}
                                        <FaArrowRight className="ml-2" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </section>
    );
};

export default ServiceSection;